import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.areTokensValid()) {
    return true; // Allow navigation
  }

  try {
    const refreshed = await authService.refreshTokens();
    if (refreshed && authService.areTokensValid()) {
      return true;
    }
  } catch (e) {
    // Ignore error and redirect to login
  }

  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};
